/**
 * @fileoverview Student Signup page wrapper
 * @description Main component with two-column layout - single step form
 */

import { useForceEnglish } from 'hooks'
import { NotificationProvider } from 'context'
import { SchoolLogoColor } from '@legacy/common/types/whitelabel'
import Logo from '@legacy/common/components/shared/Logo'
import { LumiarToastContainer } from '@legacy/common/_components/LumiarToast'
import IllustrationSrc from '@legacy/assets/images/signup-illustration.webp'
import { StudentSignupProvider } from './context/StudentSignupContext'
import { SignupForm } from './components/SignupForm'
import {
  PageContainer,
  LogoContainer,
  ContentWrapper,
  IllustrationColumn,
  IllustrationImage,
  FormColumn,
} from './styles'

/**
 * Student Signup page content with two-column layout
 */
const SignupContent = () => {
  return (
    <PageContainer>
      <LogoContainer>
        <Logo color={SchoolLogoColor.Primary} />
      </LogoContainer>
      <ContentWrapper>
        <IllustrationColumn>
          <IllustrationImage src={IllustrationSrc} alt='Signup illustration' />
        </IllustrationColumn>
        <FormColumn>
          <SignupForm />
        </FormColumn>
      </ContentWrapper>
    </PageContainer>
  )
}

/**
 * Student Signup page wrapper with providers
 */
export const StudentSignup = () => {
  useForceEnglish()

  return (
    <NotificationProvider>
      <StudentSignupProvider>
        <LumiarToastContainer />
        <SignupContent />
      </StudentSignupProvider>
    </NotificationProvider>
  )
}
